import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RouteLoadingService {

  constructor() { }
  
  private _loadingRoute: string | null = null;
  
  public set loadingRoute(val: string | null) {
    this._loadingRoute = val;
  }
  
  public get loadingRoute() {
    return this._loadingRoute;
  }

  public get isLoading() {
    return !!this.loadingRoute;
  }
}
